/** 앱 전역 상수 */
export const DB_NAME = 'codex';
export const SCHEMA_VERSION = 1;
export const APP_VERSION = '0.1.0';
export const PROJECT_ID = 'project-main';

/** 고정 시드 타임스탬프 — 결정적 roundtrip을 위해 (2026-06-01T00:00:00Z) */
export const SEED_TS = Date.parse('2026-06-01T00:00:00.000Z');
